(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockAbschlussHinweis', {
            bindings: {
                vertragsnummern: '<abahVertragsnummern',
                angebotModel: '<abahAngebotModel',
                options: '<abahOptions'
            },
            templateUrl: 'bloecke/abschlusshinweis/blockAbschlussHinweis.html',
            controller: BlockAbschlussHinweisController,
            controllerAs: 'blockAbschlussHinweisVm'
        });

    BlockAbschlussHinweisController.$inject = [
        'lodash',
        'AppConfig',
        'AuthenticationService',
        'IntegrationService',
        'MiscUtilsService',
        'FormatUtilsService'
    ];
    function BlockAbschlussHinweisController(_, AppConfig, AuthenticationService, IntegrationService, MiscUtilsService, FormatUtilsService) {
        var vm = this;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        vm.enrichVertragsnummerLink = enrichVertragsnummerLink;

        function activate() {
            vm.options = vm.options || {};

            if (AppConfig.MESSAGES.hinweisReiterAbschlussAllgemein) {
                vm.hinweisAllgemein = _.size(vm.vertragsnummern) > 0 ? AppConfig.MESSAGES.hinweisReiterAbschlussAllgemeinVertrag : AppConfig.MESSAGES.hinweisReiterAbschlussAllgemein;
            }
        }

        function onInit() {
            activate();
        }

        function onChanges() {
            activate();
        }

        function enrichVertragsnummerLink(vertragsnummer) {
            var link = vertragsnummer;

            if (
                (
                    AuthenticationService.getSession().tokenLoginSession ||
                    IntegrationService.getIntegrationParams().isTokenLogin
                ) &&
                !MiscUtilsService.isAppModus() &&
                vertragsnummer
            ) {
                link = '<a href="' + FormatUtilsService.replace(AppConfig.APP.urls.kundenportalVertragDetails, _.replace(vertragsnummer, /[^0-9]/g, '')) + '" target="_blank">' + vertragsnummer + '</a>';
            }

            return link;
        }
    }

})();
